// extracted by mini-css-extract-plugin
export default {"preloader":"qmLy0uQT","loading-message":"TAqx69at"};